import React, { lazy } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const IMG = 'https://cdn.magicpatterns.com/uploads/qAdcnA19zq2jRkKqM7oszS/confianza_y_garantia_.webp';
export function GuaranteeSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-66" data-mp="9t1lj1da838w">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16" data-id="element-67" data-mp="etpngi31u4hw">
        <Reveal data-id="element-68" data-mp="jtbxyjrht6n0">
          <div className="mx-auto max-w-sm overflow-hidden rounded-3xl shadow-xl shadow-rosa/15" data-id="element-69" data-mp="jrr3eu56hnp5">
            <img src={IMG} alt="Manos sosteniendo una delicada flor rosa, símbolo de cuidado y confianza" className="h-full w-full object-cover" loading="lazy" data-id="element-70" data-mp="nst4zhmkibua" />
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-71" data-mp="12jk0azndbt25">
          <span className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-rosa/15 text-rosa" data-id="element-72" data-mp="12kbjfazs3ybj">
            <ShieldCheckIcon className="h-8 w-8" strokeWidth={1.5} data-id="element-73" data-mp="17imrphafe0rn" />
          </span>
          <h2 className="mt-6 font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-74" data-mp="25sq8t4a9ij7m">
            Empieza con tranquilidad: tienes 7 días de garantía
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-tinta/75" data-id="element-75" data-mp="1vszdj0dvo06h">
            Quiero que empieces desde la calma, no desde la duda. Por eso tienes{' '}
            <strong className="font-semibold text-tinta" data-id="element-76" data-mp="1ruig58k9e429">
              7 días de garantía de satisfacción
            </strong>
            .
          </p>
          <p className="mt-4 text-lg leading-relaxed text-tinta/75" data-id="element-77" data-mp="2jkd5v6c13vrg">
            Si en los primeros 7 días aplicaste las rutinas diarias, registraste
            tu progreso en la app y aun así sientes que este método no es para
            ti, te devolvemos tu dinero. Así de simple.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-tinta/75" data-id="element-78" data-mp="379xzcj5t6bez">
            Tú solo tienes que dar el primer paso. El riesgo lo asumo yo, porque
            confío en lo que este acompañamiento puede hacer por ti.
          </p>
        </Reveal>
      </div>
    </section>;
}